import { requestJobs } from "hiringagent-dashboard/actions/jobs";
import { jobsSliceSelector } from "hiringagent-dashboard/selectors";
import { createConnector } from "common/connectors/utils";

export default createConnector("WithJobs", jobsSliceSelector, {
  onLoad: requestJobs,
});
